import { render, staticRenderFns } from "./DeclarationIrg301BisPage.vue?vue&type=template&id=3f384b1b&scoped=true&"
import script from "./DeclarationIrg301BisPage.vue?vue&type=script&lang=js&"
export * from "./DeclarationIrg301BisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f384b1b",
  null
  
)

export default component.exports